import ApiService from '@/common/api.service';
import Toast from '@/common/toast';

const resource = 'totp';

const TotpService = {
    async get2FaBarcode() {
        let promise = null;
        try {
            promise = await ApiService.get(resource + '/barcode');
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async validateCode(validationCode) {
        let promise = null;
        try {
            promise = await ApiService.post(resource + '/validate', { validationCode: validationCode });
            Toast.showSaveOkToastI18n('global.menu.account.success2factorauth');
        } catch (e) {
            Toast.showSaveErrorToastI18n('global.menu.account.error2factorauth');
        }
        return promise;
    },
    async disable2Fa(validationCode) {
        let promise = null;
        try {
            promise = await ApiService.post(resource + '/deactivate', { validationCode: validationCode });
            Toast.showSaveOkToastI18n('global.menu.account.success2factorauthdeactivate');
        } catch (e) {
            Toast.showSaveErrorToastI18n('global.menu.account.error2factorauth');
        }
        return promise;
    },
    async send2FaDeactivationEmail(client_data) {
        let promise = null;
        try {
            promise = await ApiService.post(resource + '/send2FaDeactivationEmail', client_data);
            Toast.showSaveOkToastI18n('global.menu.account.success2factoremail');
        } catch (e) {
            Toast.showSaveErrorToastI18n('global.menu.account.error2factoremail');
        }
        return promise;
    },
    async deactivate2Fa(client_data) {
        let promise = null;
        try {
            promise = await ApiService.post(resource + '/deactivate2fa', client_data);
        } catch (e) {
            Toast.showSaveErrorToastI18n('global.menu.account.error2factordisable');
            return e;
        }
        return promise;
    },
};

export default TotpService;
